import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import HomePage from './Pages/Home';
import NotFoundPage from './Pages/NotFoundPage';
import DevTestingPage from './Pages/DevTestingPage';
import TAC from "./Pages/Legal/TAC"


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route exact path="/dev" element={<DevTestingPage/>}/>
          <Route exact path="/" element={<HomePage/>}/>
          <Route exact path="/legal/tac" element={<TAC/>}/>
          <Route path="*" element={<NotFoundPage
            NotFoundPageTitle="404"
            NotFoundPageParagraph="Oh Snap, It looks like that page doesn't exist.Lets take you back to the home page:"
            NotFoundLinkLabel="Home"
            NotFoundLinkSrc="/"
          />}
          />
          {/* <Route exact path="/link" element={<element/>}/> */}
          {/* <Route exact path="/link" element={<element/>}/>*/}
        </Routes>
      </Router>
    </>
  );
}


export default App;


